import { HASHTAG as BASE } from "../route";

export const APILOGS = BASE.sub("/apilogs");
export const APILOG = BASE.sub("/apilogs/:apiLogId");
